
(function ($) {

	function getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;" + "SameSite=Lax";
	}

	var urlParams = getUrlVars();
	if (urlParams["pdf"] === "1") return; // don't display cookie banner when saving to pdf

	var $cookieNotice = $('.cookie-notice');
	if ($cookieNotice === 0) return; //If cookie doesnt html does not exist then return

	var hasConsent = getCookie('boeconsent');
	if (hasConsent === "") {
		// User has not dismissed the cookie
		setTimeout(function () {
			showPanel();
		}, 1000);

	}

	// hide and show panel
	function showPanel() {

		$cookieNotice.addClass('is-visible');
		bindClickEvent();
		bindFocusEvent();
	}
	function bindClickEvent() {

		const daysMax = 90,
			daysMin = 1,
			consentNecessary = 'necessary',
			consentAnalytics = 'analytics';

		$('[data-cookie]').on('click', function (e) {

			var thisAttr = $(this).attr('data-cookie');

			if (thisAttr === 'analytics') {
				addCookie(consentAnalytics, daysMax);
				if (typeof (SetAnalytics) != 'undefined') {
					var analytics = SetAnalytics || {}; // set to SetAnalytics if it exists
					if (analytics.setTagManager) {
						SetAnalytics.setTagManager();
					}
				}
				// update iFrameBlocker
				IframeBlocker.init();
			} else {
				addCookie(consentNecessary, daysMin);
			}

			removePanel();

			// prevent default click behavior
			e.preventDefault();

		});
	}
	function removePanel() {

		$cookieNotice.removeClass('is-visible');

	}
	function addCookie(consentValue, days) {

		setCookie('boeconsent', consentValue, days);
	}
	function bindFocusEvent() {

		// if user tab outside the cookie panel area 
		$('body').on('keyup', function (e) {

			var $thisTarget = $(e.target),
				clickedOutside = $thisTarget.closest('.cookie-notice').length === 0;

			if (clickedOutside) {

				// remove panel
				if ($('.cookie-notice').hasClass('is-visible')) {
					removePanel();
				}
			}
		});

	}


})(jQuery);